import { UsersManagement } from 'pages/users';
import { useAdminUserManagementData } from './useAdminUserManagementData';

export const AdminUserManagement: React.FC = () => {
  const {
    users,
    providers,
    organizations,
    roles,
    isLoading,
    isError,
    errorMessage,
  } = useAdminUserManagementData();

  return (
    <UsersManagement
      users={users}
      providers={providers}
      organizations={organizations}
      roles={roles}
      isLoading={isLoading}
      isError={isError}
      errorMessage={errorMessage}
    />
  );
};
